import { h } from "preact";
import { useEffect, useState } from "preact/hooks";
import styles from "./style.scss";

const STORAGE_KEY = "itconsult_cookie_consent_accepted";

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    try {
      setIsVisible(localStorage.getItem(STORAGE_KEY) !== "true");
    } catch (e) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "true");
    } catch (e) {}

    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className={styles.cookieConsent} role="dialog" aria-label="Согласие на использование cookie">
      <p>
        Сайт использует технические cookie для работы версии для слабовидящих и сохранения пользовательских настроек.
        Продолжая пользоваться сайтом, вы соглашаетесь с использованием cookie. Подробнее -{" "}
        <a href="/privacy">в политике конфиденциальности</a>.
      </p>
      <button type="button" onClick={handleAccept}>
        Понятно
      </button>
    </div>
  );
};

export default CookieConsent;
